import {invert} from 'lodash';

/**
 * Webflow credit type keys used to identify different credit currencies.
 * Analogous to ENTITLEMENT_KEYS for entitlements.
 */
export const CREDIT_TYPES = {
  AI_CREDITS: 'aiCredits',
} as const;

/**
 * Pre-computed inverted map: Webflow credit value → constant key name.
 */
export const INVERTED_CREDIT_TYPES = invert({
  ...CREDIT_TYPES,
});

/**
 * Credit types that may be granted as promotional credits by admin tools
 * (the admin handler and the bulk grant script).
 */
export const PROMOTIONAL_CREDIT_TYPES = [CREDIT_TYPES.AI_CREDITS] as const;

/**
 * HTTP statuses for which a Stigg credit-balance read is treated as the
 * provider being unavailable. The server fail-open gate and the Usage page
 * outage note both key off this set.
 */
export const CREDIT_BALANCE_PROVIDER_UNAVAILABLE_STATUSES: ReadonlySet<number> =
  new Set([429, 503, 504]);
